import { render, staticRenderFns } from "./owner-form.vue?vue&type=template&id=1af328b8"
import script from "./owner-form.vue?vue&type=script&lang=js"
export * from "./owner-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports